'use strict';
import BasePreprocessor from './BasePreprocessor';

export default class PagingPreprocessor extends BasePreprocessor {
	constructor(personalizationService) {
		super();
		this.personalizationService = personalizationService;

		Object.defineProperty(this, 'page', {
			enumerable: true,
			get() {
				return this._page;
			},
			set: this.setPage,
		});

		Object.defineProperty(this, 'pageSize', {
			enumerable: true,
			get() {
				return this._pageSize;
			},
			set: this.setPageSize,
		});

		Object.defineProperty(this, 'pageSizes', {
			enumerable: true,
			get() {
				return this._pageSizes;
			},
		});

		Object.defineProperty(this, 'firstItemNumber', {
			enumerable: true,
			get() {
				return this._firstItemNumber;
			},
		});

		Object.defineProperty(this, 'lastItemNumber', {
			enumerable: true,
			get() {
				return this._lastItemNumber;
			},
		});

		Object.defineProperty(this, 'firstPage', {
			enumerable: true,
			get() {
				return this._firstPage;
			},
		});

		Object.defineProperty(this, 'lastPage', {
			enumerable: true,
			get() {
				return this._lastPage;
			},
		});

		Object.defineProperty(this, 'totalItems', {
			enumerable: true,
			get() {
				return this._totalItems;
			},
			set(totalItems) {
				this._totalItems = totalItems;
				this._countProperties();
			},
		});
	}

	init(executor, config) {
		var pageSize = config.pageSize,
			pageSizes = config.pageSizes;

		this._page = 0;
		this._totalItems = 0;
		this._pageSizes = Array.isArray(pageSizes) ? pageSizes : [20];
		this._pageSize = pageSize || pageSizes[0];
		this._executor = executor;

		this._countProperties();
	}

	initPersonalization(personalizationKey) {
		this.personalizationKey = personalizationKey;

		return this.personalizationService.getPageSize().then(
			function (personalizedPageSize) {
				if (!isNaN(personalizedPageSize)) {
					this._pageSize = personalizedPageSize;
					this._countProperties();
				}
			}.bind(this)
		);
	}

	setPage(newPage) {
		newPage = parseInt(newPage);

		if (isNaN(newPage) || this._page === newPage || (this._page < newPage && this.lastPage) || (this._page > newPage && this.firstPage)) {
			return;
		}

		this._page = newPage;
		this._countProperties();

		this.changed();
	}

	setPageSize(newPageSize) {
		newPageSize = parseInt(newPageSize);
		if (!isNaN(newPageSize) && this._pageSize !== newPageSize) {
			this._pageSize = newPageSize;
			this._page = 0;
			this._countProperties();
			this.personalizationService.savePageSize(this._pageSize);
			this.changed();
		}
	}

	nextPage() {
		this.page++;
	}

	prevPage() {
		this.page--;
	}

	_countProperties() {
		this._firstItemNumber = this._page * this._pageSize + 1;
		this._lastItemNumber = this._firstItemNumber + this._pageSize - 1;

		this._checkFirstLastPage();
	}

	_checkFirstLastPage() {
		if (this._totalItems > 0 && this._lastItemNumber > this._totalItems) {
			this._lastItemNumber = this._totalItems;
		}

		this._firstPage = this._page === 0;
		this._lastPage = this._totalItems === this._lastItemNumber;
	}
}
PagingPreprocessor.$inject = ['mx.SolutionBuilderAgent.PersonalizationService'];
